import { useEffect, useRef, useState } from "react"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./ScrollableLayout.styled"

type ScrollableLayoutProps = {
    buttons: React.ReactNode
    className?: string
    content: React.ReactNode
}

export const ScrollableLayout = (props: ScrollableLayoutProps) => {
    const {
        buttons,
        className,
        content,
    } = props

    const scrollableRef = useRef<HTMLDivElement>(null)
    const [showShadow, setShowShadow] = useState(false)
    const isMobile = useIsMobileDevice()

    useEffect(() => {
        const scrollableEl = scrollableRef.current
        if (!scrollableEl) {
            return null
        }

        const checkScroll = () => {
            if (scrollableEl.scrollHeight > scrollableEl.clientHeight) {
                setShowShadow(scrollableEl.scrollTop + scrollableEl.clientHeight < scrollableEl.scrollHeight)
            } else {
                setShowShadow(false)
            }
        }

        checkScroll()
        scrollableEl.addEventListener("scroll", checkScroll)
        window.addEventListener("resize", checkScroll)
        const observer = new MutationObserver(checkScroll)
        observer.observe(scrollableEl, {
            childList: true,
            subtree: true,
        })

        return () => {
            scrollableEl.removeEventListener("scroll", checkScroll)
            window.removeEventListener("resize", checkScroll)
            observer.disconnect()
        }
    }, [scrollableRef])

    return (
        <Styled.ScrollableLayoutContainer className={className}>
            <Styled.ContentContainer ref={scrollableRef}>
                {content}
            </Styled.ContentContainer>
            <Styled.ButtonsContainer showShadow={showShadow} isMobile={isMobile}>
                {buttons}
            </Styled.ButtonsContainer>
        </Styled.ScrollableLayoutContainer>
    )
}
